export default "__VITE_ASSET__Bmc9TYeK__"